import { useI18n, t } from "@bookingcom/lingojs-react";
import { useSelector } from "react-redux";
import { getSearch } from "../../store/search/selectors.js";
import { getFlight } from "../../store/flightDetails/selectors.js";
import { getOrder } from "../../store/order/selectors.js";
import useProfiler from "../../hooks/useProfiler.js";
import useRouteName from "../../hooks/useRouteName.js";
import flights_apex_web_fare_included_copy_blackout from "../../utils/experiments/apex/flights_apex_web_fare_included_copy_blackout.js";
const useFareFeaturesHeading = () => {
    const search = useSelector(getSearch);
    const flight = useSelector(getFlight);
    const order = useSelector(getOrder);
    const i18n = useI18n();
    const { isMobile } = useProfiler();
    const routeName = useRouteName();
    const totalTravellersOnOrder = order?.airOrder?.passengerPrices?.length || 0;
    const totalTravellersOnSearch = (search.adults || 0) + (search.children || []).length;
    const totalTravellersOnFunnel = order?.airOrder?.passengerPrices?.length || flight?.travellers?.length || 0;
    const hasMultipleTravellers = totalTravellersOnSearch > 1 || totalTravellersOnFunnel > 1 || totalTravellersOnOrder > 1;
    const isSoloTraveller = !hasMultipleTravellers;
    const isSearchResultsPage = routeName === "searchresults";
    const isBrandedFaresPage = routeName === "checkout-fare";
    if (isSoloTraveller && (isSearchResultsPage || isBrandedFaresPage)) {
        flights_apex_web_fare_included_copy_blackout.trackStages({
            isSearchResultsPage,
            isBrandedFaresPage,
            isMobile: isMobile()
        });
        if (flights_apex_web_fare_included_copy_blackout.trackWithDefaultStage()) {
            return "";
        }
    }
    return i18n.trans(hasMultipleTravellers ? t("flights_bf_included_total") : t("flight_fare_included"));
};
export default useFareFeaturesHeading;
